export default __webpack_public_path__ + "df8bb8279c4d35405e4456cb1af0a833.svg";